import styles from './FJVideoRemoveBgBg.module.less';
import PropTypes from 'prop-types';
import FJMenuTab from '../../../../common/components/FJMenuTab/FJMenuTab';
import { useMemo } from 'react';
import FJConfig from '../../../../config/FJConfig';
import FJSidePhotoListPanel from '../../../../common/components/FJSidePhotoListPanel/FJSidePhotoListPanel';
import FJSideModelSelectedInputBox from '../../../../common/components/FJSideModelSelectedInputBox/FJSideModelSelectedInputBox';
import FJColorPanel from '../../../../common/components/FJColorPanel/FJColorPanel';
import FJUploadIcon from '../../../../assets/svg/upload.svg?react';
import { useCallback } from 'react';
import { useRef } from 'react';
import FJConstant from '../../../../constants/FJConstant';
import { useState } from 'react';

const FJVideoRemoveBgBg = ({
    menuTabList,
    curMenuIndex,
    colorList,
    activeColor,
    curSelectBgData,

    flexClipBgLoadStatus,
    backgroundPhotoList,
    customUploadBgFileList,
    bgUsePhotoLoadingList,

    aiTextToImageHistoryList,
    aiTextToImageHistoryLoadStatus,

    setCurMenuIndex,

    handleColorChange,
    showBgListModel,
    hideBgListModel,
    addSelectColor,
    handleBgItemClick,
    uploadBg,
    handleGenerateNow,
    removeClick,
    onClickRetry,
    onClickAiRetry,
}) => {
    const fileInputRef = useRef(null);
    const [isShowSlide, setIsShowSlide] = useState(false);

    const { bgSizeList, bgList } = useMemo(() => {
        const bgList = [];
        const bgSizeList = [];

        customUploadBgFileList.forEach(item => {
            bgList.push({
                id: item.id,
                url: item.src,
                isCustomUpload: true,
            });
            bgSizeList.push({
                width: 166,
                height: 166 / (item.width / item.height),
            });
        });

        backgroundPhotoList.forEach(item => {
            bgList.push({
                name: item.name,
                url: `${FJConfig.flexClipBgPhotoThumbnailBaseUrl}${item.name}`,
            });
            bgSizeList.push({
                width: 166,
                height: 166 / (item.width / item.height),
            });
        });

        return { bgSizeList, bgList };
    }, [backgroundPhotoList, customUploadBgFileList]);

    const { aiBgList, aiBgSizeList } = useMemo(() => {
        const aiBgList = [];
        const aiBgSizeList = [];

        aiTextToImageHistoryList.forEach(item => {
            aiBgList.push({
                id: item.id,
                url: item.imgUrl,
            });
            aiBgSizeList.push({
                width: 166,
                height: 166 / (item.width / item.height),
            });
        });

        return { aiBgList, aiBgSizeList };
    }, [aiTextToImageHistoryList]);

    const handleFileChange = useCallback(
        e => {
            const file = e.target.files[0];
            uploadBg && uploadBg(file);
            e.target.value = '';
        },
        [uploadBg],
    );

    const handleUploadBg = useCallback(() => {
        fileInputRef.current.click();
    }, []);

    const isShowColor = useMemo(() => {
        return activeColor !== '';
    }, [activeColor]);

    const isShowImg = useMemo(() => {
        return (curSelectBgData && curSelectBgData.url) || activeColor === '';
    }, [curSelectBgData, activeColor]);

    const selectedName = useMemo(() => {
        if (curSelectBgData && curSelectBgData.url) {
            return curSelectBgData.isAiPhoto ? 'ai-photo' : 'photo';
        }

        if (isShowColor) {
            return 'color';
        }

        return 'transparent1';
    }, [curSelectBgData, isShowColor]);

    return (
        <FJSideModelSelectedInputBox
            title={'background'}
            titleTextClassName={styles.title_text}
            selectedName={selectedName}
            checkBoxText={'apply-to-all'}
            isShowArrowIcon={true}
            showModelCallback={() => {
                showBgListModel();
                setIsShowSlide(true);
            }}
            hideModelCallback={() => {
                hideBgListModel();
                setIsShowSlide(false);
            }}
            isShowImg={isShowImg}
            imgUrl={
                curSelectBgData
                    ? curSelectBgData.url
                    : selectedName === 'transparent1'
                      ? FJConfig.transparentPngUrl
                      : ''
            }
            isShowColor={isShowColor}
            color={activeColor}
            className={styles.panel_box}
        >
            <div className={styles.panel}>
                <FJMenuTab list={menuTabList} curIndex={curMenuIndex} onChange={setCurMenuIndex}></FJMenuTab>

                {curMenuIndex === 0 && isShowSlide && (
                    <FJSidePhotoListPanel
                        scrollerClassName={styles.scroller}
                        btn1Text={'transparent1'}
                        btn2Text={'upload'}
                        btn2Icon={<FJUploadIcon className={styles.upload_icon} />}
                        btn1Click={removeClick}
                        btn2Click={handleUploadBg}
                        itemClick={handleBgItemClick}
                        list={bgList}
                        sizeList={bgSizeList}
                        status={flexClipBgLoadStatus}
                        curSelectKey={curSelectBgData ? curSelectBgData.key : ''}
                        loadingList={bgUsePhotoLoadingList}
                        onClickRetry={onClickRetry}
                        btn1Disabled={
                            flexClipBgLoadStatus === FJConstant.LOADING || flexClipBgLoadStatus === FJConstant.ERROR
                        }
                        btn2Disabled={
                            flexClipBgLoadStatus === FJConstant.LOADING || flexClipBgLoadStatus === FJConstant.ERROR
                        }
                    />
                )}
                {curMenuIndex === 1 && (
                    <FJColorPanel
                        colorList={colorList}
                        activeColor={activeColor}
                        onChange={handleColorChange}
                        onHide={addSelectColor}
                        removeClick={removeClick}
                        btuText={'transparent1'}
                    />
                )}
                {curMenuIndex === 2 && isShowSlide && (
                    <FJSidePhotoListPanel
                        scrollerClassName={styles.scroller}
                        itemClick={item => handleBgItemClick(item, true)}
                        list={aiBgList}
                        sizeList={aiBgSizeList}
                        status={aiTextToImageHistoryLoadStatus}
                        isTextToImageHistory={true}
                        isShowBottom={aiBgList.length > 0}
                        curSelectKey={curSelectBgData ? curSelectBgData.key : ''}
                        btn1Click={removeClick}
                        btn1Text={'transparent1'}
                        btn2Text={'generate-now'}
                        btn2Click={handleGenerateNow}
                        btn2ClassName={styles.generate_now_btn}
                        loadingList={bgUsePhotoLoadingList}
                        onClickRetry={onClickAiRetry}
                    />
                )}

                <input
                    ref={fileInputRef}
                    type='file'
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                    multiple={false}
                    accept='image/*'
                />
            </div>
        </FJSideModelSelectedInputBox>
    );
};

FJVideoRemoveBgBg.propTypes = {
    menuTabList: PropTypes.array,
    curMenuIndex: PropTypes.number,
    flexClipBgLoadStatus: PropTypes.string,
    backgroundPhotoList: PropTypes.array,
    setCurMenuIndex: PropTypes.func,
    showBgListModel: PropTypes.func,
    hideBgListModel: PropTypes.func,
    aiTextToImageHistoryList: PropTypes.array,
    aiTextToImageHistoryLoadStatus: PropTypes.string,
    colorList: PropTypes.array,
    activeColor: PropTypes.string,
    handleColorChange: PropTypes.func,
    addSelectColor: PropTypes.func,
    handleBgItemClick: PropTypes.func,
    curSelectBgData: PropTypes.object,
    uploadBg: PropTypes.func,
    customUploadBgFileList: PropTypes.array,
    removeClick: PropTypes.func,
    loadingList: PropTypes.array,
    bgUsePhotoLoadingList: PropTypes.array,
    handleGenerateNow: PropTypes.func,
    onClickRetry: PropTypes.func,
    onClickAiRetry: PropTypes.func,
};

export default FJVideoRemoveBgBg;
